module.exports = __webpack_public_path__ + "static/assets/49a37c66334f482776183132af23cd00.png";